import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  MenuOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { CSS } from "@dnd-kit/utilities";
import { Button, Input, message, Space, Switch, Table } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IMG_DELIVERY_CARD } from "../../../../assets/images";
import { IconDelete, IconEdit, IconSearch } from "../../../../assets/icons";
import CreateUpdateCountryModal from "./CreateUpdateCountryModal/CreateUpdateCountryModal";
import api from "../../../../api/api";
import DeleteModal from "./DeleteModal/DeleteModal";
import UpdateStatusModal from "./UpdateStatusModal/UpdateStatusModal";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AddCity from "./AddCity/AddCity";
import DeleteCityModal from "./DeleteCityModal/DeleteCityModal";
import UpdateCityModal from "./UpdateCityModal/UpdateCityModal";
import UpdateCityStatusModal from "./UpdateCityStatusModal/UpdateCityStatusModal";
import EditRegion from "./EditRegion/EditRegion";
import { localStorage } from "@utils";

const { Search } = Input;

const RootContainer = styled.div`
  .ant-table {
    .ant-btn-default {
      border: none;
      background: ${(props) => props.theme.backgroundColor};
      color: ${(props) => props.theme.primaryColor} !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      :hover {
        background: ${(props) => props.theme.backgroundColor} !important;
      }
    }
    svg {
      cursor: pointer;
    }
  }
`;

const Title = styled.div`
  padding-bottom: 16px;
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

const NewBox = styled.div`
  padding: 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 8px;
`;

const LeftBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: center;
  border-right: 1px solid #b9b9b9;
  .ant-btn {
    width: 172px;
    height: 48px;
  }
`;

const ImageWrapper = styled.div`
  padding: 0 5%;
`;

const Image = styled.img.attrs({
  alt: "img",
  src: IMG_DELIVERY_CARD,
})`
  height: 146px;
  width: auto;
`;

const BoldText = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #1e1e1e;
`;

const SubTitle = styled.div`
  padding: 24px 0;
  font-size: 20px;
  font-weight: 700;
  color: #1e1e1e;
`;

const List = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ItemCard = styled.div`
  min-width: 22%;
  padding: 16px;
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${(props) =>
    props.active ? props.theme.backgroundColor : "#F5F5F5"};
  border: ${(props) =>
    props.active ? `1px solid ${props.theme.primaryColor}` : "none"};
  border-radius: 8px;
  cursor: pointer;
  > div:first-child {
    display: flex;
    gap: 24px;
  }
  svg {
    cursor: pointer;
  }
  .ant-switch {
    min-width: auto;
    height: 24px;
  }
  .ant-switch-handle {
    top: 3px;
  }
  .ant-switch-inner {
    width: 40px;
    height: 24px;
    background: #f00;
  }
  .ant-switch-checked .ant-switch-inner {
    background: #009800 !important;
  }
`;

const NameText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #272727;
`;

const BlueText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #006afb;
`;

const TitleWrapper = styled.div`
  padding-top: 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  .ant-btn-primary {
    width: 172px;
    height: 48px;
  }
`;

const Item = ({
  selected,
  item,
  handleEditClicked,
  handleDeleteClicked,
  handleStatusClicked,
  handleItemClicked,
}) => {

  const storeLang = localStorage.getStoreLang() || [];
  const langCount = storeLang?.length;

  return (
    <ItemCard active={selected ? 1 : 0} onClick={() => handleItemClicked(item)}>
      <BlueText>{item.name?.primary}</BlueText>
      <NameText>{langCount === 2 ? item.name?.secondary : ""}</NameText>
      <Space onClick={(e) => e.stopPropagation()}>
        <Switch
          checked={item.is_active}
          onClick={() => handleStatusClicked(item)}
        />
        <IconEdit onClick={() => handleEditClicked(item)} />
        <IconDelete onClick={() => handleDeleteClicked(item)} />
      </Space>
    </ItemCard>
  );
};

const DraggableRow = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props["data-row-key"] });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...props.style,
  };

  return <tr {...props} ref={setNodeRef} style={style} />;
};

const DragMenu = ({ record }) => {
  const { attributes, listeners } = useSortable({ id: record.id });

  return (
    <span {...attributes} {...listeners}>
      <MenuOutlined className="drag-icon" />
    </span>
  );
};

const DeliveryArea = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [openStatus, setOpenStatus] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // countries
  const [country, setCountry] = useState(null);
  const [cities, setCities] = useState([]);
  const [openDeleteCity, setOpenDeleteCity] = useState(false);
  const [openEditCity, setOpenEditCity] = useState(false);
  const [openCityStatus, setOpenCityStatus] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const sensors = useSensors(useSensor(PointerSensor));

  const storeLang = localStorage.getStoreLang() || [];
  const langCount = storeLang?.length;

  // Debounced city fetch on country or search change
  useEffect(() => {
    if (country) {
      const handler = setTimeout(() => {
        getCities(country, searchKeyword);
      }, 500);
      return () => clearTimeout(handler);
    }
  }, [country, searchKeyword]);

  // Load countries on mount
  useEffect(() => {
    getCountries();
  }, []);

  const getCities = ({ id: country_id }, search = "") => {
    setLoading(true);
    api
      .getCities({ country_id, search })
      .then(({ data }) => {
        setCities(data);
        setLoading(false);
      })
      .catch((error) => {
        message.error(error?.message || "Failed to load cities");
        setLoading(false);
      });
  };

  const getCountries = () => {
    api
      .getCountries()
      .then(({ data }) => {
        setData(data);
        if (data.length > 0) {
          setCountry(state?.country || data[0]);
        }
      })
      .catch((error) => {
        message.error(error?.message || "Failed to load countries");
      });
  };

  const handleClose = () => {
    setOpen(false);
    setIsEdit(false);
    setSelectedItem({});
  };

  const successCallback = () => {
    getCountries();
  };

  const handleEditClicked = (item) => {
    setSelectedItem(item);
    setIsEdit(true);
    setOpen(true);
  };

  const handleDeleteClicked = (item) => {
    setSelectedItem(item);
    setOpenDelete(true);
  };

  const handleStatusClicked = (item) => {
    setSelectedItem(item);
    setOpenStatus(true);
  };

  const handleDeleteClose = () => {
    setSelectedItem({});
    setOpenDelete(false);
  };

  const handleStatusClose = () => {
    setSelectedItem({});
    setOpenStatus(false);
  };

  const changeStatusSuccessCallback = (id) => {
    setData((prev) =>
      prev.map((x) => (x.id === id ? { ...x, is_active: !x.is_active } : x))
    );
  };

  const handleAddCityClicked = () => {
    navigate(`add-city/${country.id}/${country.name?.primary}`);
  };

  const handleItemClicked = (item) => {
    setCountry(item);
    setSearchKeyword(""); // Reset search
  };

  const handleDeleteCityClicked = (item) => {
    setSelectedItem(item);
    setOpenDeleteCity(true);
  };

  const handleDeleteCityClose = () => {
    setSelectedItem({});
    setOpenDeleteCity(false);
  };

  const handleEditCityClicked = (item) => {
    setSelectedItem(item);
    setOpenEditCity(true);
  };

  const handleEditCityClose = () => {
    setSelectedItem({});
    setOpenEditCity(false);
  };

  const editCitySuccessCallback = (item) => {
    setCities((prev) => prev.map((x) => (x.id === item.id ? item : x)));
  };

  const handleCityStatusClicked = (item) => {
    setSelectedItem(item);
    setOpenCityStatus(true);
  };

  const handleCityStatusClose = () => {
    setSelectedItem({});
    setOpenCityStatus(false);
  };

  const changeCityStatusSuccessCallback = (id) => {
    setCities((prev) =>
      prev.map((x) => (x.id === id ? { ...x, is_active: !x.is_active } : x))
    );
  };

  const handleEditRegionClicked = (item) => {
    navigate(
      `edit-region/${item.id}/${item.name?.primary}/${country.name?.primary}`
    );
  };

  const onSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const columns = [
    {
      title: "",
      dataIndex: "drag",
      width: 30,
      render: (_, record) => <DragMenu record={record} />,
    },
    {
      key: "no",
      title: "No.",
      render: (_, record, index) => index + 1,
    },
    {
      key: "name",
      dataIndex: "name",
      title: "City",
      render: (_, record) =>
        `${record.name?.primary} ${langCount === 2 ? '('+record.name?.secondary+')' : ""}`,
    },
    {
      key: "region",
      dataIndex: "region",
      title: "Region",
      render: (_, record) =>
        record?.Townships?.length === 0
          ? "-"
          : record?.Townships?.map((item, key) => (
              <div key={key}>
                {`${item.name?.primary} ${langCount === 2 ? '('+item.name?.secondary+')' : ""}`}
              </div>
            )),
    },
    {
      key: "is_active",
      dataIndex: "is_active",
      title: "Status",
      render: (_, record) => (
        <Switch
          checked={record.is_active}
          onClick={() => handleCityStatusClicked(record)}
        />
      ),
    },
    {
      key: "actions",
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            type="default"
            onClick={() => handleEditRegionClicked(record)}
          >
            Edit Region
          </Button>
          <IconEdit onClick={() => handleEditCityClicked(record)} />
          <IconDelete onClick={() => handleDeleteCityClicked(record)} />
        </Space>
      ),
    },
  ];

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const draggedId = active.id;
    const targetId = over.id;

    setCities((citiesList) => {
      const oldIndex = citiesList.findIndex((city) => city.id === draggedId);
      const newIndex = citiesList.findIndex((city) => city.id === targetId);

      if (oldIndex === -1 || newIndex === -1) return citiesList;

      const newOrder = arrayMove(citiesList, oldIndex, newIndex);

      // Call API to persist new order
      api
        .updateCitiesSwap(draggedId, targetId)
        .then(() => {
          message.success("City order updated successfully");
        })
        .catch((err) => {
          message.error("Failed to update city order");
          console.error("Swap order error:", err);
          // Optional: rollback UI on error
          return citiesList; // revert drag
        });

      return newOrder; // Update UI order
    });
  };

  const NewCard = () => (
    <NewBox>
      <LeftBox>
        <BoldText>Countries & Cities You Deliver To</BoldText>
        <Text>
          You can create countries and cities that deliver your products.
        </Text>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpen(true)}
        >
          Create Country
        </Button>
      </LeftBox>
      <ImageWrapper>
        <Image />
      </ImageWrapper>
    </NewBox>
  );

  return (
    <RootContainer>
      <Title>Delivery Area</Title>
      <NewCard />

      {!loading && data.length > 0 && (
        <>
          <SubTitle>Countries ({data.length})</SubTitle>
          <List>
            {data.map((item, key) => (
              <Item
                key={key}
                selected={item.id === country?.id}
                item={item}
                handleEditClicked={handleEditClicked}
                handleDeleteClicked={handleDeleteClicked}
                handleStatusClicked={handleStatusClicked}
                handleItemClicked={handleItemClicked}
              />
            ))}
          </List>

          <TitleWrapper>
            <SubTitle style={{ flex: 1 }}>
              {`Delivered Cities in ${country?.name?.primary} (${cities.length})`}
            </SubTitle>
            <Input
              placeholder="Search cities"
              value={searchKeyword}
              onChange={onSearchChange}
              style={{ width: 260, height: 48 }}
              prefix={<IconSearch />}
              allowClear
            />
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={handleAddCityClicked}
            >
              Add City
            </Button>
          </TitleWrapper>

          {/* Drag-and-drop context for cities */}
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={cities.map((city) => city.id)}
              strategy={verticalListSortingStrategy}
            >
              <Table
                columns={columns}
                dataSource={cities}
                pagination={false}
                loading={loading}
                rowKey="id"
                components={{
                  body: {
                    row: DraggableRow,
                  },
                }}
              />
            </SortableContext>
          </DndContext>
        </>
      )}

      {/* Modals */}
      <CreateUpdateCountryModal
        open={open}
        isEdit={isEdit}
        item={selectedItem}
        handleClose={handleClose}
        successCallback={successCallback}
      />
      <DeleteModal
        id={selectedItem.id}
        open={openDelete}
        handleClose={handleDeleteClose}
        successCallback={successCallback}
      />
      <UpdateStatusModal
        id={selectedItem.id}
        open={openStatus}
        handleClose={handleStatusClose}
        successCallback={changeStatusSuccessCallback}
      />
      <DeleteCityModal
        id={selectedItem.id}
        name={selectedItem.name?.primary}
        open={openDeleteCity}
        handleClose={handleDeleteCityClose}
        successCallback={successCallback}
      />
      <UpdateCityModal
        open={openEditCity}
        item={selectedItem}
        handleClose={handleEditCityClose}
        successCallback={editCitySuccessCallback}
      />
      <UpdateCityStatusModal
        id={selectedItem.id}
        open={openCityStatus}
        handleClose={handleCityStatusClose}
        successCallback={changeCityStatusSuccessCallback}
      />
    </RootContainer>
  );
};

const Entry = () => {
  return (
    <Routes>
      <Route path="" element={<DeliveryArea />} />
      <Route path="add-city/:country_id/:country_name" element={<AddCity />} />
      <Route
        path="edit-region/:city_id/:city_name/:country_name"
        element={<EditRegion />}
      />
    </Routes>
  );
};

export default Entry;
